export const saveUserHistory = async (term, userId) => {
  if (!userId || !term) return;

  try {
    await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/searchhistory/save-history`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          searchTerm: term,
          userId,
        }),
      }
    );
  } catch (err) {
    console.error("Failed to save user history", err);
  }
};
